import gql from "graphql-tag";

export const MY_TIMESHEET_GET_SELECTED_REQUEST = gql`
  query mySheetTimesheet($_id: String!) {
    mySheetTimesheet(_id: $_id) {
      _id
      contractId
      name
      description
      startTime
      endTime
      projectId
      projectName
      clientId
      clientName
      costId
      costName
      state
      createdAt
      createdBy
      approvedAt
      approvedBy
      rejectedAt
      rejectedBy
    }
  }
`;
